import { __decorate, __metadata } from "tslib";
import _ from 'lodash';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let FormatNumberServiceImpl = class FormatNumberServiceImpl {
    constructor() { }
    formatNumber(num) {
        if (!_.isNumber(num))
            return num;
        // eslint-disable-next-line prefer-const
        let [left, right] = num.toString().split('.');
        left = left.replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,');
        return _.compact([left, right]).join('.');
    }
    formatNumberByKilo(num, digits, toThousands) {
        // 处理符号
        let sign = '';
        if (num < 0) {
            sign = '-';
            num = -num;
        }
        // 处理数据
        const si = [{ value: 1, symbol: '' },
            { value: 1E3, symbol: 'K' },
            { value: 1E6, symbol: 'M' },
            { value: 1E9, symbol: 'B' },
            { value: 1E12, symbol: 'T' }];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        let i;
        for (i = si.length - 1; i > 0; i--) {
            if (num >= si[i].value) {
                break;
            }
        }
        if (digits === undefined)
            digits = 2;
        let number = (num / si[i].value).toFixed(digits).replace(rx, '$1');
        if (toThousands) {
            // 处理小数点
            // eslint-disable-next-line prefer-const
            let [left, right] = number.toString().split('.');
            left = left.replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,');
            number = [left, right].filter(Boolean).join('.');
        }
        const symbol = si[i].symbol;
        return sign + number + symbol;
    }
};
FormatNumberServiceImpl = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], FormatNumberServiceImpl);
export { FormatNumberServiceImpl };
